import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';

function CollectionPoolDescriptionHelper({ infos }) {
  return (
    <Container className='container_infos'>
      <Word className='infos_title' value={infos.title} />
      {Object.entries(infos.subtitles).map(([title, value]) => {
        return (
          <Container key={title}>
            <Word className='infos_subtitle' value={title} />
            {Array.isArray(value) ? (
              <ul className='circle-list'>
                {value.map((val) =>
                  val ? (
                    <li key={val}>
                      <span style={{ fontWeight: 'bold', fontSize: 14 }}>- {val}</span>
                    </li>
                  ) : (
                    <li key='nr'>NR</li>
                  ),
                )}
              </ul>
            ) : (
              <Word className='infos_subtitle_value' value={value as string} />
            )}
          </Container>
        );
      })}
    </Container>
  );
}

export default CollectionPoolDescriptionHelper;
